function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "03_Dashboard_Green",
  transform: "translate(-663.000000, -542.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(664.000000, 538.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-right",
  transform: "translate(5.500000, 10.500000) scale(-1, 1) translate(-5.500000, -10.500000) translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 5.5,
  x2: 9.8,
  y2: 5.5,
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  strokeLinejoin: "round",
  points: "5.5 0 11 5.5 5.5 11"
})))));

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD85989E-8D11-4ABD-9BDE-9E627680AB16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0c6efcb1.svg";
export { ForwardRef as ReactComponent };